if($('.in-index').length){
    $('.homepage-group-title').each(function(){
        if(!$(this).find('span').length){
            $(this).wrapInner('<span></span>')
        }
    })
   
}

